import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

/**
 * Single-purpose service that signals when the typing animation has completed.
 * Uses a ReplaySubject(1) so that late subscribers (e.g. the final suggestions phase)
 * always receive the most recent finish event even if they subscribe after it fired.
 */
@Injectable({ providedIn: 'root' })
export class AiChatFinishTypingService {
    private readonly finishTypingSubject$ = new ReplaySubject<void>(1);
    public readonly finishTyping$: Observable<void> = this.finishTypingSubject$.asObservable();

    public notifyFinishTyping(): void {
        this.finishTypingSubject$.next();
    }
}
